<section class="main-banner-area main-banner-area-four">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="banner-text">
                            <h1>Innovación en la Nube</h1>
                            <p>Impulsa tu negocio con servicios confiables de cómputo en la nube, hosting y
                                almacenamiento seguro.</p>

                            <div class="banner-btn">
                                <a class="default-btn" routerLink="/about-us">Conócenos</a>
                                <!-- <a class="default-btn active" routerLink="/shared-hosting">Buy Now</a> -->
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12">
                        <div class="banner-img">
                            <img class="banner-img-part-two wow fadeInDown" data-wow-delay=".2s"
                                src="assets/img/shape/lnve.png" alt="">
                            <div class="banner-img-part-one wow fadeInDown" data-wow-delay=".5s">
                                <img src="assets/img/shape/lnve.png" alt="Image">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-line-one">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-one.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-two.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-three.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-two.png" alt="Image">
        <img src="assets/img/banner-shape/banner-shape-three.png" alt="Image">
    </div>
</section>

<div class="search-domain-area search-domain-area-four">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-4 col-md-12">
                <div class="search-text">
                    <h2>Directorio de Servicios</h2>
                </div>
            </div>

            <div class="col-lg-8 col-md-12">
                <div class="search-domain">
                    <form class="domain-wrap">
                        <input maxlength="50" [(ngModel)]="search" type="text" class="input-domain"
                            placeholder="Palabras clave o nombres de los servicios que busca." name="Domain">
                        <button class="default-btn" (click)="searchService()">Buscar</button>


                    </form>

                </div>
            </div>
        </div>
    </div>
</div>


<section class="shared-hosting-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-3 col-md-6">
                <ul class="hosting-list">
                    <li><a routerLink="/services/cloud-computing">Cómputo en la Nube</a></li>
                    <li><a routerLink="/services/cloud-storage">Almacenamiento en la Nube</a></li>
                    <li><a routerLink="/services/dedicated-hosting">Alojamiento Especializado</a></li>
                    <li><a routerLink="/services/dedicated-database">Alojamiento Base de Datos</a></li>
                    <li><a routerLink="/services/gaming-servers">Servidores para videojuegos</a></li>
                    <li><a routerLink="/services/intermediate-data-protection">Resguardo de Datos</a></li>
                    <li><a routerLink="/services/equipment-administration">Administración de Equipos</a></li>
                </ul>
            </div>

            <div class="col-lg-5 col-md-6">
                <div class="shared-hosting-content">
                    <h2>enCloud</h2>
                    <p class="text-justify">Somos tu socio estratégico como proveedor de servicios en la nube (CSP) y de servicios administrados (MSP). Ofrecemos soluciones integrales que incluyen almacenamiento masivo, resguardo seguro de datos y hospedaje de servidores dedicados para aplicaciones empresariales, videojuegos y machine learning. Diseñamos tecnología propia, como routers optimizados, y brindamos soporte especializado a investigadores y centros de investigación con necesidades avanzadas de procesamiento y análisis de datos. Nuestro enfoque combina infraestructura confiable, gestión personalizada y seguridad de primer nivel para satisfacer las demandas de cualquier sector.</p>
                </div>


            </div>

            <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
                <div class="shared-hosting-img">
                    <img src="assets/img/encloud_services.svg" alt="Image">
                </div>
            </div>
        </div>
    </div>
</section>


<section class="customer-support-area pt-100 pb-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="customer-title">
                    <h2>Soporte al Cliente enCloud: Tu Aliado en la Nube</h2>
                    <p class="text-justify">Sabemos que la continuidad de tu negocio depende de un soporte confiable y eficiente.
                        Por eso, nuestro servicio de atención al cliente está diseñado para brindarte tranquilidad y respaldo en todo momento.</p>
                </div>

                <ul class="custom-list">
                    <li><strong>Disponibilidad 24/7:</strong>  Estamos contigo siempre, listos para atender cualquier inconveniente o consulta.</li>
                    <li><strong>Respuesta rápida y eficiente:</strong> Sabemos que el tiempo es crítico, por lo que nuestro equipo resuelve tus problemas en el menor tiempo posible.</li>
                    <li><strong>Soporte especializado:</strong> Nuestros expertos en tecnologías de la nube te ofrecen soluciones avanzadas y personalizadas.</li>
                    <li><strong>Atención multicanal:</strong> Ya sea por chat, correo o llamada, estamos donde nos necesites para garantizar tu comodidad.</li>
                </ul>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="support-img">
                    <img style="width: 500px;" src="assets/img/support-img.svg" alt="Image">
                </div>
            </div>
        </div>
    </div>
</section>


<section class="services-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Servicios de Alojamiento en la Nube Confiables.</h2>
            <p class="text-justify">Ofrecemos soluciones de hosting diseñadas para garantizar estabilidad, velocidad y escalabilidad.
                Nuestra infraestructura avanzada te permite enfocarte en tu negocio mientras nosotros gestionamos tus necesidades en la nube de manera segura y eficiente.</p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-sm-6">
                <div class="single-technology">
                    <div class="technology-icon-bg">
                        <img src="assets/img/shape/technology-icon-bg.png" alt="Image">
                        <i class="fa-solid fa-rocket"></i>
                    </div>
                    <h3>Disponibilidad</h3>
                    <p>Garantizamos la continuidad de nuestros servicios con una infraestructura robusta y centros de datos de última generación. Gracias a nuestro monitoreo 24/7 y sistemas de respaldo automáticos, aseguramos que tu negocio nunca se detenga.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="single-technology active">
                    <div class="technology-icon-bg">
                        <img src="assets/img/shape/technology-icon-bg.png" alt="Image">
                        <i class="fa-solid fa-gauge-high"></i>
                    </div>
                    <h3>Máxima velocidad </h3>
                    <p>Experimenta un rendimiento excepcional con nuestra arquitectura optimizada. Con almacenamiento de alta velocidad y redes de baja latencia, garantizamos que tus aplicaciones y sitios web funcionen con la máxima eficiencia.</p>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6 offset-sm-3 offset-lg-0">
                <div class="single-technology">
                    <div class="technology-icon-bg">
                        <img src="assets/img/shape/technology-icon-bg.png" alt="Image">
                        <i class="fa-solid fa-coins"></i>
                    </div>
                    <h3>Precios competitivos</h3>
                    <p>Brindamos soluciones de alto rendimiento a precios accesibles y competitivos. Nos enfocamos en ofrecer valor real para tu negocio, garantizando el mejor servicio sin comprometer tu presupuesto y necesidades.</p>
                </div>
            </div>
        </div>
    </div>
</section>


<app-sites-area [ptb]="ptb"></app-sites-area>

<app-clients-says></app-clients-says>


<app-latest-news [pt]="pt_news" [pb]="pb"></app-latest-news>


<app-contact-form [section]="section" [pt]="pt" [pb]="pb"></app-contact-form>


<app-clients [pt]="pt" [pb]="pb"></app-clients>